import { Sprite, Texture, Container } from 'pixi.js';
import { InteractionEvents, Tween } from '@cc/pixi-app';
import { ScreenBase } from './ScreenBase';
import { ButtonBase } from '../common/ButtonBase';
import { session } from '../session';
import { avatarGenerator } from '../common/AvatarGenerator';
import { TiledParser } from '../map/tiled-parser';
import { storageManager } from '../common/StorageManager';
import { dataImporter } from './../DataImporter';

export class ScreenMissionSelect extends ScreenBase {

    init() {
        this.packData = dataImporter.currPack;
        // Setup pack.
        this.setupPack(this.packData);

        storageManager.setMissionComplete(this.packData.id, this.packData.missions[0].id);

        this.app.sound.play(this.packData.missionSelect.bgMusic);

        this.background = new Sprite.from(this.packData.missionSelect.bg);
        this.background.anchor.set(0.5);
        this.background.height = this.app.resizer.height;
        this.background.scale.x = this.background.scale.y;
        this.logo = new Sprite.from(this.packData.missionSelect.logo);
        this.logo.anchor.set(0.5);
        this.logo.y = -575;

        this.addChild(this.background);
        this.addChild(this.logo);

        if (storageManager.packs[this.packData.id].includes(this.packData.missions[1].id) === true) {
            this.galleryButton = new ButtonBase(new Texture.from("album_btn"));
            this.galleryButton.anchor.set(0.5);
            this.galleryButton.y = 50;
            this.galleryButton.scale.set(0);
            this.galleryButton.on(InteractionEvents.PointerTap, this.openGallery, this);
            this.addChild(this.galleryButton);
        }

        this.createButtons(this.packData.missionSelect.buttonSpacing);
        this.ui.addChild(this.createMuteButton('TopRight'));
        // this.ui.addChild(this.createHelpButton('TopRight'));
        this.ui.addChild(this.createAvatarEditorButton('TopLeft'));
        this.ui.addChild(this.createBackButton('TopLeft', "packs", 'home_btn'));

        this.avatar = avatarGenerator.getAnimation("avatar-front-anim", "front", false);
        this.avatar.position.set(0, 1400);
        this.avatar.setAnimation(0, "idle", true);
        this.background.addChild(this.avatar);
    }

    setupPack(packData) {
        let tiledParser = new TiledParser({
            tileIdToMoveType: packData.world.tileIdToMoveType,
            tileIdToCollectibleType: packData.world.tileIdToCollectibleType,
            dataLayerIds: packData.world.dataLayers
        });
        let maps = new Map();
        packData.world.maps.forEach(mapData => {
            // Temp injection of map data. Future system could do this in loader middleware.
            // if (mapData.id === 'main') mapData.data = dataImporter.currMap;

            let map = tiledParser.generateMap(mapData);

            maps.set(map.id, map);
        });
        session.maps = maps;
    }

    createButtons(buttonSpacing) {
        this.missionCont = new Container();
        for (var i = 0; i < this.packData.missions.length; i++) {
            var button = this.createMissionButton(this.packData.missions[i]);
            if (i < this.packData.missions.length / 2) {
                button.x = buttonSpacing * i;
                button.y = -200;
            }
            else {
                button.x = buttonSpacing * (i - (this.packData.missions.length / 2));
                button.y = 300;
            }


            this.missionCont.addChild(button);
        }

        this.missionCont.x = (((-this.missionCont.children.length / 2) + 1) * buttonSpacing) / 2;
        this.background.addChild(this.missionCont);
        for (var j = 0; j < this.missionCont.children.length; j++) {
            this.animateCarouselItem(this.missionCont.children[j], 250 + (j * 450));
        }
        if (storageManager.packs[this.packData.id].includes(this.packData.missions[1].id) === true) {
            this.wait(this.missionCont.children.length * 450).call(() => {
                this.tween(this.galleryButton.scale)
                    .to({ x: 1, y: 1 }, 250, createjs.Ease.getElasticOut(1.1, 1.5));
            });
        }
        this.wait(this.missionCont.children.length * 450).call(() => {
            this.animateAvatarIn(200)
        });
    }

    createMissionButton(mission) {
        //creating an unlocked mission button
        if (storageManager.packs[this.packData.id].includes(mission.id) === true) {
            let button = new ButtonBase(new Texture.from(mission.packImage));
            button.on(InteractionEvents.PointerTap, () => this.onButtonClick(mission), this);
            button.anchor.set(0.5);

            //Last unlocked and not completed button pulsing
            if ((storageManager.packs[this.packData.id].includes(mission.id) === true) &&
                !storageManager.completeMissions[this.packData.id]) {
                this.tween(button.scale, { loop: true, })
                    .to({ x: 0.93, y: 0.93 }, 900, createjs.Ease.sineInOut)
                    .to({ x: 1, y: 1 }, 900, createjs.Ease.sineInOut);
                button.on(InteractionEvents.MouseOver, () => {
                    Tween.removeTweens(button.scale);
                });
                button.on(InteractionEvents.MouseOut, () => {
                    this.tween(button.scale, { loop: true, })
                        .to({ x: 0.93, y: 0.93 }, 900, createjs.Ease.sineInOut)
                        .to({ x: 1, y: 1 }, 900, createjs.Ease.sineInOut);
                });

            } else if (storageManager.completeMissions[this.packData.id].includes(mission.id) === false) {
                this.tween(button.scale, { loop: true, })
                    .to({ x: 0.93, y: 0.93 }, 900, createjs.Ease.sineInOut)
                    .to({ x: 1, y: 1 }, 900, createjs.Ease.sineInOut);
                button.on(InteractionEvents.MouseOver, () => {
                    Tween.removeTweens(button.scale);
                });
                button.on(InteractionEvents.MouseOut, () => {
                    this.tween(button.scale, { loop: true, })
                        .to({ x: 0.93, y: 0.93 }, 900, createjs.Ease.sineInOut)
                        .to({ x: 1, y: 1 }, 900, createjs.Ease.sineInOut);
                });
            }

            return button;

            //creating a locked mission button
        } else {
            let button = new ButtonBase(new Texture.from(mission.packImageLocked));
            button.on(InteractionEvents.PointerTap, () => this.app.sound.play("06-locked-mission"), this);
            button.anchor.set(0.5);

            return button;
        }
    }

    animateCarouselItem(button, delay) {
        let pos = Object.assign({}, button.position);
        button.position.set(325, 0);
        button.scale.set(0);
        this.tween(button.scale)
            .wait(delay - 50)
            .to({ x: 1, y: 1 }, 100, createjs.Ease.linear);
        this.tween(button)
            .wait(delay)
            .to({ x: pos._x, y: pos._y }, 350, createjs.Ease.getElasticOut(1.1, 1.5));
    }

    animateAvatarIn(d) {
        this.tween(this.avatar)
            .wait(d)
            .to({ y: 900 }, 900, createjs.Ease.getElasticOut(1.1, 1.5));
    }

    animateAvatarOut(d) {
        this.tween(this.avatar)
            .wait(d)
            .to({ y: 1400 }, 900, createjs.Ease.getElasticIn(1.1, 1.5));
    }

    onButtonClick(mission) {
        this.app.sound.play("02-ui-click");
        dataImporter.currMission = mission;
        this.animateAvatarOut();
        this.wait(1100).call(() => this.app.showScreen('game', dataImporter.currPack.tags.mission));
    }

    openGallery() {
        this.app.sound.play("02-ui-click");
        this.app.showScreen('photoGallery', dataImporter.currPack.tags.photoGallery);
    }
}
